export enum ScreenPaths {
  // ----- Root -----
  Root = '/',

  // ----- Public -----
  Login = '/login/office',
  LoginDailyCareLog = '/login/daily-care-log',
  LoginQuickAccess = '/login/quick-access/:navigationTarget',

  RecoverPassword = '/authentication/password/recover',
  // Search parameter "token" needed
  ReplacePassword = '/authentication/password/replace',
  ValidateInvite = '/validate/invite',
  // Search parameter "voucherCode" needed
  AcceptRelationshipInvite = '/invites/relationship',
  // Search parameter "voucherCode" needed
  CreateInformalCaregiverAccount = '/create-account/informal-caregiver',
  // Search parameter "voucherCode" needed
  AcceptAffiliationInvite = '/invites/affiliation',
  // Search parameter "voucherCode" needed
  CreateProfessionalCaregiverAccount = '/create-account/professional-caregiver',

  // ----- Private -----
  Office = '/office',
  Office_SystemAdministrator = '/system-administrator',
  Office_Partner = '/partner',
  Office_Me = '/me',
  // Needs the id of the entity after "/entity"
  Office_ProfessionalCaregiver = '/professional-caregiver/entity',
  // Needs the id of the senior after "/senior"
  Office_InformalCaregiver = '/informal-caregiver/senior',

  // Daily Care Log
  DailyCareLog = '/daily-care-log/entity',
  DailyCareLog_Home = '/home',
  DailyCareLog_Seniors = '/seniors',
  DailyCareLog_SeniorTasks = '/seniors/:userId/tasks',
  DailyCareLog_Tasks = '/tasks',
  DailyCareLog_Shift = '/shift',
  DailyCareLog_CareService = '/care-services/:careServiceId',
  DailyCareLog_Grouped_Tasks = '/grouped-tasks/:activityTypeId',
  DailyCareLog_Occurrences = '/occurrences',
  DailyCareLog_AttendanceTracker = '/attendance-tracker',
  DailyCareLog_NewAttendanceRecord = '/attendance-tracker/new',
  DailyCareLog_AttendanceTrackerSession = '/attendance-tracker/:sessionId',
  DailyCareLog_NewOccurrence = '/occurrences/new',
  DailyCareLog_HandleOccurrence = '/occurrences/:occurrenceId',
  // => Me
  Me_Home = '/home',
  Me_Profile = '/profile',
  Me_ProfileDetails = '/profile/details',
  Me_Notifications = '/notifications',

  // Needs the id of the entity after "/entity"
  Me_MyAffiliationsEntity = '/my-affiliations/entity',
  // Needs the id of the senior after "/senior"
  Me_MyRelationshipsSenior = '/my-relationships/senior',

  // => System Administrator
  SystemAdministrator_Statistics = '/statistics',
  SystemAdministrator_Activity = '/activity',
  SystemAdministrator_Applications = '/applications',
  SystemAdministrator_Seniors = '/seniors',
  SystemAdministrator_Caregivers = '/caregivers',
  SystemAdministrator_Entities = '/entities',
  SystemAdministrator_Devices = '/devices',
  SystemAdministrator_UserCards = '/user-cards',
  SystemAdministrator_ApiDocs = '/api-docs',
  SystemAdministrator_Licenses = '/licenses',
  SystemAdministrator_ApplicationCategories = '/application-categories',
  SystemAdministrator_Playlists = '/playlists',
  SystemAdministrator_GdprErasureRequests = '/gdpr-erasure-requests',

  // => Partner
  Partner_Home = '/home',
  Partner_ApiDocs = '/api-docs',

  // => Professional Caregiver/Digital Inclusion
  ProfessionalCaregiver_DigitalInclusion_Applications = '/applications',
  ProfessionalCaregiver_DigitalInclusion_Application = '/applications/:applicationId',
  ProfessionalCaregiver_DigitalInclusion_Photos = '/photos',
  ProfessionalCaregiver_DigitalInclusion_Photo = '/photos/:id',
  ProfessionalCaregiver_DigitalInclusion_Cards = '/user-cards',
  ProfessionalCaregiver_DigitalInclusion_Card = '/user-cards/:id',
  ProfessionalCaregiver_DigitalInclusion_Devices = '/devices',
  ProfessionalCaregiver_DigitalInclusion_Device = '/devices/:deviceId',
  ProfessionalCaregiver_DigitalInclusion_Services = '/services',
  ProfessionalCaregiver_DigitalInclusion_Service = '/services/:id',
  ProfessionalCaregiver_DigitalInclusion_Playlists = '/playlists',
  ProfessionalCaregiver_DigitalInclusion_PlaylistItems = '/playlists/:playlistId',

  // => Professional Caregiver
  ProfessionalCaregiver_Dashboard = '/dashboard',
  ProfessionalCaregiver_Statistics = '/statistics',
  ProfessionalCaregiver_Licenses = '/licenses',
  ProfessionalCaregiver_Seniors = '/seniors',
  ProfessionalCaregiver_ProfessionalCaregivers = '/professional-caregivers',
  ProfessionalCaregiver_DigitalInclusion = '/digital-inclusion',
  ProfessionalCaregiver_EntityServices = '/entity-services',
  ProfessionalCaregiver_Activity = '/activity',
  ProfessionalCaregiver_Applications = '/applications',
  ProfessionalCaregiver_EntityDetails = '/details',
  ProfessionalCaregiver_UserCards = '/user-cards',
  ProfessionalCaregiver_Photos = '/photos',
  ProfessionalCaregiver_Playlists = '/playlists',
  ProfessionalCaregiver_Shifts = '/shifts',
  ProfessionalCaregiver_ShiftsManagement = '/management',
  ProfessionalCaregiver_ShiftsAllocations = '/allocations',
  ProfessionalCaregiver_ActivitiesPlanning = '/activities-planning',
  ProfessionalCaregiver_RolesAndPermissions = '/roles-and-permissions',
  ProfessionalCaregiver_AttendanceTracker = '/attendance-tracker',
  ProfessionalCaregiver_AttendanceTrackerAssignments = '/assignments',
  ProfessionalCaregiver_AttendanceTrackerRegistry = '/registry',
  ProfessionalCaregiver_CareServices = '/care-services',

  // => Professional Caregiver/Settings
  ProfessionalCaregiver_Settings = '/settings',
  ProfessionalCaregiver_InstitutionSettings = '/institution',
  ProfessionalCaregiver_Occurrences = '/occurrences',
  ProfessionalCaregiver_Occurrences_New = '/occurrences/new',

  // => Professional Caregiver/Settings/Institution/--
  ProfessionalCaregiver_InstitutionSettings_Profile = '/profile',
  ProfessionalCaregiver_InstitutionSettings_Settings = '/settings',
  ProfessionalCaregiver_InstitutionSettings_Activity = '/activity',
  ProfessionalCaregiver_InstitutionSettings_Seniors = '/seniors',
  ProfessionalCaregiver_InstitutionSettings_ProfessionalCaregivers = '/professional-caregivers',
  ProfessionalCaregiver_InstitutionSettings_AssociateDevice = 'devices/associate',
  ProfessionalCaregiver_InstitutionSettings_Statistics = '/statistics',
  ProfessionalCaregiver_InstitutionSettings_Licenses = '/licenses',
  ProfessionalCaregiver_InstitutionSettings_Templates = '/templates',
  ProfessionalCaregiver_InstitutionSettings_TemplatesEdit = '/:templateId',
  ProfessionalCaregiver_InstitutionSettings_Occurrences = '/occurrences',
  ProfessionalCaregiver_InstitutionSettings_QuickAccessDevices = '/quick-access-devices',
  ProfessionalCaregiver_ActivitySectorSettings = '/activity-sector/:activitiesSectorId',
  ProfessionalCaregiver_Configurations = '/configurations',

  // => Entity Activity Plan
  Entity_Planner = '/planner',
  Entity_Planner_Calendar = '/planner/calendar',
  Entity_Planner_Reminders = '/planner/reminders',
  Entity_Planner_PendingTasks = '/planner/pending-tasks',

  // => Professional-Caregiver/Senior Dashboard
  Senior_Dashboard = '/dashboard',
  Senior_Dashboard_General = '/general',
  Senior_Dashboard_Activity = '/activity',
  Senior_Dashboard_Health = '/health',

  // => Professional-Caregiver/Senior
  Senior_IndividualPlan = '/individual-plan',
  Senior_CarePlan = '/care-plan/:activitiesSectorId',
  Senior_CareAndActivity = '/care-and-activity',
  Seniors_IndividualPlan = '/individual-plan',
  Senior_PersonalData = '/personal-data',
  Senior_DigitalInclusion = '/digital-inclusion',
  Senior_CareServices = '/care-services',
  Senior_Reminders = '/reminders',

  // => Professional-Caregiver/Senior/Personal Data
  Senior_Profile = '/profile',
  Senior_Caregivers = '/caregivers',
  Senior_Applications = '/applications',
  Senior_Application = '/applications/:applicationId',
  Senior_Devices = '/devices',
  Senior_Device = '/devices/:deviceId',
  Senior_AssociateDevice = '/devices/associate',
  Senior_UserCards = '/user-cards',
  Senior_UserCard = '/user-cards/:id',
  Senior_AssociateUserCard = '/user-cards/associate',
  Senior_Statistics = '/statistics',
  Senior_Health = '/health',
  Senior_Playlists = '/playlists',
  Senior_PlaylistItems = '/playlists/:playlistId',
  Senior_PlaylistItem = '/playlists/:playlistId/items/:itemId',
  Senior_InviteCaregiver = '/caregivers/invite',
  Senior_InvitesHistory = '/caregivers/invites',
  Senior_Affiliations = '/affiliations',
  Senior_Attachments = '/attachments',

  // => Informal caregiver
  InformalCaregiver_Activity = '/activity',
  InformalCaregiver_Profile = '/profile',
  InformalCaregiver_Medias = '/medias',
  InformalCaregiver_Reminders = '/reminders',
  InformalCaregiver_Services = '/services',
  InformalCaregiver_Applications = '/applications',
  InformalCaregiver_Application = '/applications/:applicationId',

  // ----- Legacy integration -----
  LegacyIntegration = '/legacy-integration',

  // ----- Deleted queries -----
  SeniorsDeletedQuery = 'deleted-senior-name',
  ProfessionalCaregiversDeletedQuery = 'deleted-professional-caregiver-name',
  EntityServicesDeletedQuery = 'deleted-service-title',
  UserCardsDeletedQuery = 'deleted-user-card-name',
  DevicesDeletedQuery = 'deleted-device-name',
  EntitiesDeletedQuery = 'deleted-entity-name',
  EntityPhotosDeletedQuery = 'deleted-entity-photo-id',
  ApplicationCategoriesDeletedQuery = 'deleted-application-category-name',
  PlaylistDeletedQuery = 'deleted-playlist-name',
  PlaylistItemDeletedQuery = 'deleted-playlist-item-name',
}
